import { formatCustomDate } from "../../../helpers/dateTools";
import { invoicesTypes } from "./types";

const {
  CLEAR_INVOICES,
  SET_INPUTS,
  GET_INVOICES,
  SELECT_INVOICE_ID,
  CANCEL_INVOICE,
  SUBSTITUTE_INVOICE,
  SET_FORM_CANCEL_INVOICE,
  SET_FORM_SUBSTITUTE_INVOICE,
  SET_EMAIL_INVOICE,
  UPDATE_FILES_INVOICE,
  CHECK_NOTE_MIGRATIONS,
  RESTORE_INITIAL,
} = invoicesTypes;

const INITIAL_STATE = {
  startDate: formatCustomDate(new Date(), "-"),
  endDate: formatCustomDate(new Date(), "-"),
  stations: [],
  paymentTypes: [],
  invoices: [],
  invoiceId: "",
  formCancelInvoice: false,
  formSubstituteInvoice: false,
  askForCancelMigration: false,
  sendEmailInvoice: false,
  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: [],
  },
};

export const invoicesReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CLEAR_INVOICES:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    //request
    case SET_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case GET_INVOICES:
      return {
        ...state,
        invoices: Array.isArray(payload) ? payload : [],
      };
    case SELECT_INVOICE_ID:
      return {
        ...state,
        invoiceId: payload,
      };
    case SUBSTITUTE_INVOICE:
      let substituteState = [...state.invoices];
      const idxSub = substituteState.findIndex(
        (invoice) => invoice.id === payload.id,
      );
      if (idxSub === -1) return state;
      if (Object.keys(payload?.replacement || {}).length) {
        if (payload.isInstantlyCancelled)
          substituteState[idxSub] = {
            ...substituteState[idxSub],
            status: "CANCELADA",
            urlAccuse: payload?.replacement?.url,
          };
        else
          substituteState[idxSub] = {
            ...substituteState[idxSub],
            status: "EN_PROCESO",
          };
      }

      substituteState = [
        ...substituteState,
        {
          ...substituteState[idxSub],
          id: payload.newId,
          status: "VIGENTE",
          payment: payload?.payment,
          urlAccuse: payload?.new,
          date: formatCustomDate(new Date(), "-"),
        },
      ];
      return {
        ...state,
        invoices: substituteState,
      };
    case CANCEL_INVOICE:
      let deleteState = [...state.invoices];
      const idx = deleteState.findIndex((invoice) => invoice.id === payload.id);
      if (idx === -1) return state;
      if (payload.isInstantlyCancelled)
        deleteState[idx] = {
          ...deleteState[idx],
          status: "CANCELADA",
          urlAccuse: payload.url,
        };
      else
        deleteState[idx] = {
          ...deleteState[idx],
          status: "EN_PROCESO",
        };
      return {
        ...state,
        invoices: deleteState,
      };
    case SET_FORM_CANCEL_INVOICE:
      return {
        ...state,
        formCancelInvoice: payload,
      };
    case SET_FORM_SUBSTITUTE_INVOICE:
      return {
        ...state,
        formSubstituteInvoice: payload,
      };
    case SET_EMAIL_INVOICE:
      return {
        ...state,
        sendEmailInvoice: payload,
      };
    case UPDATE_FILES_INVOICE:
      const idFile = state.invoices.findIndex(
        (invoice) => invoice.id === payload.id,
      );
      if (idFile !== -1) {
        let updateState = [...state.invoices];
        updateState[idFile] = {
          ...updateState[idFile],
          hasPdf: true,
          hasXml: true,
        };
        return {
          ...state,
          invoices: updateState,
        };
      }
      return state;

    case CHECK_NOTE_MIGRATIONS:
      return {
        ...state,
        askForCancelMigration: payload,
      };

    case RESTORE_INITIAL:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
